export default "__VITE_ASSET__5d704aad__"